export default "__VITE_ASSET__Qeib8L2$__"